// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BeJj","fullView":"styles_fullView__1y5rP"};